import React from "react"
import { TbDotsVertical } from "react-icons/tb"
import { useSelector } from "react-redux"
import { Dropdown, MenuItem } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import { haveAuth } from "utils"
import KtOrderCardDropDownDeleteButton from "./KtOrderCardDropDownDeleteButton"
import KtOrderCardDropDownEditButton from "./KtOrderCardDropDownEditButton"
import KtOrderCardDropDownPrintButton from "./KtOrderCardDropDownPrintButton"
import KtOrderCardDropDownSendPaymentLink from "./KtOrderCardDropDownSendPaymentLink"
import classes from "./KtOrderCardDropDown.module.scss"

const KtOrderCardDropDown = props => {
  const {
    isOrderEditable,
    isOrderSplited,
    subPaymentItems,
    tableDetails,
    tableOrder,
    setTableOrders,
    paymentDetail
  } = props

  const i18n = useTranslation()[1]

  const isOnline =
    useSelector(state => !state.internetStatus.forceOffline)

  const orderHasCoupon =
    tableOrder.couponData.some(c =>
      c.couponType === "basic"
    )

  const showEditButton =
    isOnline &&
    haveAuth(["editOrder"]) &&
    !orderHasCoupon &&
    !isOrderSplited &&
    isOrderEditable

  const showSendPaymentLink =
    isOnline &&
    !tableOrder.isCod &&
    !tableOrder.isOffline &&
    tableOrder.addedBySystem &&
    tableOrder.accountRole === "access" &&
    tableOrder.orderStatus === "pending"

  const primaryPrinter =
    haveAuth(["printerAccess"])

  const showDeleteButton =
    isOnline &&
    !isOrderSplited &&
    haveAuth(["deleteOrder"])

  const showDropDown =
    primaryPrinter ||
    showDeleteButton ||
    showSendPaymentLink

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (!showDropDown) return null

  return (
    <Dropdown
      id="id"
      pullRight={isLtr}
      className={classes["dropdown"]}
    >
      <Dropdown.Toggle
        noCaret
        className={classes["icon"]}
      >
        <TbDotsVertical
          size={20}
        />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {
          primaryPrinter &&
          <MenuItem className={classes["item"]}>
            <KtOrderCardDropDownPrintButton
              tableOrder={tableOrder}
            />
          </MenuItem>
        }
        {
          showEditButton &&
          <MenuItem className={classes["item"]}>
            <KtOrderCardDropDownEditButton
              subPaymentItems={subPaymentItems}
              tableDetails={tableDetails}
              tableOrder={tableOrder}
            />
          </MenuItem>
        }
        {
          showDeleteButton &&
          <MenuItem className={classes["item"]}>
            <KtOrderCardDropDownDeleteButton
              tableOrder={tableOrder}
              setTableOrders={setTableOrders}
            />
          </MenuItem>
        }
        {
          showSendPaymentLink &&
          <MenuItem className={classes["item"]}>
            <KtOrderCardDropDownSendPaymentLink
              tableOrder={tableOrder}
              paymentDetail={paymentDetail}
            />
          </MenuItem>
        }
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default KtOrderCardDropDown